import { Component, DestroyRef, inject, OnInit} from '@angular/core';
import {FormGroup,FormBuilder,Validators,AbstractControl,} from '@angular/forms';
import {EMAIL_VALIDATION_PATTERN,IMG_EXTENSIONS,Invalid_IMAGE_FORMAT,MULTILINGUAL_NAME_VALIDATION_PATTERN,NO_IMAGE,} from '@shared/constant/shared.constant';
import { CustomValidator } from '@shared/services/custom-validatior.abstract';
import { FileResponse } from '@core/models/file-response.model';
import { HttpErrorResponse } from '@angular/common/http';
import { ParkingLot } from '@core/models/parking-manager.model';
import { ParkingManagerService } from '@core/services/parking-manager.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastService } from '@shared/services/toast.service';
import {CountryISO,PhoneNumberFormat,SearchCountryField,} from 'ngx-intl-tel-input-gg';
import { CommonFunctions } from '@shared/common-functions';
import { ProfileService } from '@core/services/profile.service';
import { autoUnsubWith } from '@shared/services/utility.abstract';
@Component({
  selector: 'app-manager-edit-profile',
  templateUrl: './manager-edit-profile.component.html',
  styleUrls: ['./manager-edit-profile.component.scss'],
})
export class ManagerEditProfileComponent implements OnInit{
  readonly destroyRef = inject(DestroyRef);
  parkingLotId = [];
  formData: FormData = new FormData();
  imageUrl: string;
  managerForm: FormGroup;
  countryISO: CountryISO = CountryISO.UnitedStates;
  phoneNumberFormat = PhoneNumberFormat;
  separateDialCode = false;
  searchCountryField = SearchCountryField;
  preferredCountries: CountryISO[] = [
    CountryISO.UnitedStates,
    CountryISO.UnitedKingdom,
  ];
  isProfileImgError = false;
  userData: any;
  queryid: string;
  parkingLotByStates: ParkingLot[] = [];
  dummy = NO_IMAGE;

  constructor(
    private readonly service: ProfileService,
    private readonly formBuilder: FormBuilder,
    private readonly toastService: ToastService,
    private readonly parkingMangerService: ParkingManagerService,
    private readonly route: ActivatedRoute,
    private readonly router: Router
  ) {
    this.managerForm = this.formBuilder.group({
      id: [''],
      name: ['',[Validators.required,Validators.pattern(MULTILINGUAL_NAME_VALIDATION_PATTERN), Validators.minLength(3),],],
      lastName: ['', [ Validators.required, Validators.pattern(MULTILINGUAL_NAME_VALIDATION_PATTERN), Validators.minLength(3),CommonFunctions.noLeadingSpacesValidator(),],],
      email: ['',[Validators.required, Validators.pattern(EMAIL_VALIDATION_PATTERN)],],
      phone: [''],
      profileImagePath: [this.imageUrl, [this.fileSizeValidator(5)]],
      password: ['', [Validators.required, Validators.minLength(8)]],
      isActive: [false],
      parkingLotId: [this.parkingLotId, [Validators.required]],
    });
  }

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      this.queryid = params['id'];
    });
    this.getParkingManagerDetails(this.queryid);
    this.getParkingLotByStatesName();
  }

  patchForm(userData: any) {
    this.imageUrl = userData.profileImagePath;
    this.countryISO = userData.iso
   if (userData) {
      this.managerForm.patchValue({
        id: userData.id ?? '',
        name: userData.firstName ?? '',
        lastName: userData.lastName ?? '',
        email: userData.email ?? '',
        phone: userData.mobileNumber === '_' ? '' : userData.mobileNumber,
        profileImagePath: userData.profileImagePath ?? '',
        password: userData.password ?? '',
        isActive: userData.isActive,
      });
      const parkingLotIds = userData.parkingLots.map(
        (parkingLot: any) => parkingLot.id
      );
      this.managerForm.get('parkingLotId').patchValue(parkingLotIds);
      
    }
  }

  submit() {
    const req = {
      id: this.queryid,
      email: this.managerForm.value?.email,
      name: this.managerForm.value?.name,
      lastName: this.managerForm.value?.lastName,
      password: this.managerForm.value?.password,
      mobileNumber: this.managerForm.value.phone?.number ?? '',
      profileImagePath: this.managerForm.value?.profileImagePath,
      parkingLotId: this.managerForm.value?.parkingLotId,
      isActive: this.managerForm.value?.isActive,
      countryCode: this.managerForm.value.phone?.dialCode ?? '',
      iso: this.managerForm.value.phone?.countryCode ?? '',
    };
    this.isProfileImgError = false;
    if (this.managerForm.valid) {
      this.parkingMangerService.updateManagerProfile(req)
      .pipe(autoUnsubWith(this.destroyRef))
      .subscribe({
        next: (_response: any) => {
          this.toastService.showToastMessage('success','Success','Manager User Updated Successfully');
          setTimeout(() => {
            
            this.router.navigateByUrl('manager/managerlist');
          }, 1000);
        },
        error: (er: HttpErrorResponse) => {
          this.toastService.showToastMessage( 'error','Error', er.error.message);
          
        },
      });
    } else {
      CustomValidator.markFormGroupTouched(this.managerForm);
    }
  }

  onImageSelected(event: any) {
    const files = event.target.files[0];
    const maxSize = 5 * 1024 * 1024;
    if (files.size > maxSize) {
      this.isProfileImgError = true;
      return;
    }
    this.isProfileImgError = false;
    this.managerForm.get('profileImagePath')?.setValue(files);
    this.formData.append('Images', files);
    const fileExtension = files.name.split('.').pop()?.toLowerCase();
    if (!fileExtension || !IMG_EXTENSIONS.includes(fileExtension)) {
      this.toastService.showToastMessage('error','Error',Invalid_IMAGE_FORMAT);
      return;
    }
    
    this.service
      .imageUplaod(this.formData)
      .pipe(autoUnsubWith(this.destroyRef))
      .subscribe({
        next: (response: FileResponse) => {
          const data = response;
          for (const key in data) {
            if (data.hasOwnProperty(key)) {
              const url = data[key];
              this.imageUrl = url;
              this.managerForm.get('profileImagePath')?.setValue(url);
            }
          }
        },
      });
  }

  fileSizeValidator(maxSize: number) {
    return (control: AbstractControl) => {
      if (control.value) {
        const file = control.value as File;
        if (file.size > maxSize * 1024 * 1024) {
          return {
            fileSizeExceedsLimit: true,
          };
        }
      }
      return null;
    };
  }

  getParkingLotByStatesName() {
    this.parkingMangerService.getParkingLotByStatesName('').pipe(autoUnsubWith(this.destroyRef))
    .subscribe({next: (response: ParkingLot[]) => {
          this.parkingLotByStates = response;
        },
      });
  }

  getParkingManagerDetails(id) {
    this.parkingMangerService.getParkingManagerDetails(id)
    .pipe(autoUnsubWith(this.destroyRef))
    .subscribe({
      next: (response: any) => {
        this.userData = response;
        this.patchForm(this.userData);
      },
      error: (er: HttpErrorResponse) => {
        if(er.error.status !== 401){
          this.toastService.showToastMessage('error', 'Error', er.error.message);
        }
      },
    });
  }

  assignedParkingLots(id) {
    this.parkingLotId = id.value;
  }

  managerStatus(status) {
    status = !status;
    this.managerForm.get('isActive')?.setValue(status);
  }

  clearImage() {
    this.imageUrl = '';
    this.managerForm.get('profileImagePath')?.setValue(this.imageUrl);
  }
   onlyNumberInput(event: KeyboardEvent): void {
    CommonFunctions.onlyNumberInput(event);
  }
}
